// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import VueI18n from 'vue-i18n'
Vue.config.productionTip = false
Vue.use( Vuex );
Vue.use(VueI18n) ;
const store = new Vuex.Store({
  state:{
    languagecheckedID: 0
  },
  mutations: {
    "TO_PTATH" : function (state,pth) {
        state.languagecheckedID = pth;
    }
  },
  getters: {
    
  },
  actions: {

  }
})
/* eslint-disable no-new */
const i18n = new VueI18n({
  locale: 'zh-CN',    // 语言标识, 通过切换locale的值来实现语言切换,this.$i18n.locale 
  messages: {
    'zh-CN': require('./assets/i18/zh'),   // 中文语言包
    'en-US': require('./assets/i18/en')    // 英文语言包
  }
})
new Vue({
  el: '#app',
  i18n,
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js